import { useAuthStore } from 'store/authStore';

/**
 * Hook que retorna una función `can(perm)` que devuelve true
 * si el usuario autenticado tiene ese permiso.
 *
 * Uso:
 *   const can = usePermission();
 *   {can('users.create') && <button>Nuevo</button>}
 */
export function usePermission() {
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  return (perm: string): boolean => permissions.includes(perm);
}
